export const ISO_DATE_SHORT_FORMAT = /^\d{4}-\d{2}-\d{2}$/

export const DATE_FORMATS = ['yyyy-MM-dd', 'MM/dd/yyyy', 'dd/MM/yyyy']

export const PASTE_DATE_FORMATS = [
  // ISO 8601 formats (International standard)
  'yyyy-MM-dd',
  'yyyy/MM/dd',
  'yyyy.MM.dd',
  
  // US formats (Month first)
  'MM/dd/yyyy',
  'MM-dd-yyyy',
  'MM.dd.yyyy',
  'M/d/yyyy',
  'M-d-yyyy',
  
  // European/UK formats (Day first)
  'dd/MM/yyyy',
  'dd-MM-yyyy',
  'dd.MM.yyyy',
  'd/M/yyyy',
  'd-M-yyyy',
  
  // Short year formats
  'dd/MM/yy',
  'MM/dd/yy',
  'dd-MM-yy',
  'MM-dd-yy',
  'dd.MM.yy',
  'MM.dd.yy',
  
  // Text month formats
  'dd MMM yyyy',    // 15 Jan 2026
  'MMM dd, yyyy',   // Jan 15, 2026
  'dd MMMM yyyy',   // 15 January 2026
  'MMMM dd, yyyy',  // January 15, 2026
  'd MMM yyyy',
  'MMM d, yyyy',
]

export const TIME_FORMAT = 'HH:mm:ss'

export const LEAP_YEAR_EXAMPLE = 2008
